var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"appear":"","name":"slide"}},[_c(_vm.tag,{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],tag:"component",style:(_vm.style)},[(_vm.src)?_c('img',{staticClass:"masonry-image",attrs:{"src":_vm.src}}):_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }